import React from "react";
import FormulaCard from "@/components/FormulaCard";
import ComparisonCard from "@/components/ComparisonCard";
import ResultsCard from "@/components/ResultsCard";
import ToricCards from "@/components/ToricCards";
import ReportCard from "@/components/ReportCard";
import CrossCheckBar from "@/components/CrossCheckBar";

export default function ResultsSection({ result, onPrint, onDownloadPdf, downloading }) {
  if (!result) return null;
  const { request, result: data } = result;
  return (
    <div className="space-y-6 reveal">
      <FormulaCard result={data} request={request} />
      <ComparisonCard result={data} />
      <ResultsCard result={data} request={request} />
      <CrossCheckBar request={request} />
      <ToricCards result={data} />
      <ReportCard result={data} request={request} onPrint={onPrint} onDownloadPdf={onDownloadPdf} downloading={downloading} />
    </div>
  );
}
